import {
  getCartItemsCookie,
  getUserIsLoggedIn,
  getWebUserId,
} from '../../../Utils/helper';

export const offerId = '5856';
export const constSelectedProductId = '970';

export const bogoOfferApiParams = (
  productId,
  relatedProductIds,
  addQuantityBool,
  lessQuantityBool,
  addToCartBool,
  isForFirstTime,
  selectedProductId,
  changeProduct = null,
) => {
  // const { offerId } = checkToShowBogoOfferPopup();
  const params = {
    productId: productId,
    relatedProductIds: relatedProductIds,
    add_quantity: addQuantityBool,
    less_quantity: lessQuantityBool,
    addToCart: addToCartBool,
    offerId: offerId,
    isForFirstTime,
    web_product_id: getUserIsLoggedIn() ? null : getCartItemsCookie(),
    selectedProductId: selectedProductId
      ? selectedProductId
      : constSelectedProductId,
    web_user_id: getWebUserId(),
    changeProduct: changeProduct,
  };
  return params;
};
